module.exports = __webpack_public_path__ + "assets/img/right.81644782.png";